/** Screen-space angle (degrees) from a center point to a pointer, 0° = right, clockwise positive. */
export const pointerAngleDeg = (
  clientX: number,
  clientY: number,
  centerX: number,
  centerY: number,
): number => (Math.atan2(clientY - centerY, clientX - centerX) * 180) / Math.PI;

/** Smallest signed delta between two pointer angles. */
export const normalizePointerAngleDeltaDeg = (deltaDeg: number): number => {
  let delta = deltaDeg % 360;
  if (delta > 180) delta -= 360;
  if (delta < -180) delta += 360;
  return delta;
};
